import type { ReactElement, ReactNode } from 'react';

type ProjectWorkspaceSurfaceLayout = 'entity' | 'workbench';
type ProjectWorkspaceSurfaceElement = 'div' | 'main';

interface ProjectWorkspaceSurfaceProps {
  children: ReactNode;
  className?: string;
  element?: ProjectWorkspaceSurfaceElement;
  layout: ProjectWorkspaceSurfaceLayout;
}

const surfaceTestIds: Record<ProjectWorkspaceSurfaceLayout, string> = {
  entity: 'deal-workspace-surface',
  workbench: 'deal-workbench-surface',
};

const surfaceClassNames: Record<ProjectWorkspaceSurfaceLayout, string> = {
  entity: 'flex h-full w-full flex-col overflow-hidden bg-stone-50',
  workbench: 'animate-fade-in flex flex-col h-full gap-6',
};

export function ProjectWorkspaceSurface({
  children,
  className,
  element: Element = 'div',
  layout,
}: ProjectWorkspaceSurfaceProps): ReactElement {
  const classes = className
    ? `${surfaceClassNames[layout]} ${className}`
    : surfaceClassNames[layout];

  return (
    <Element data-testid={surfaceTestIds[layout]} className={classes}>
      {children}
    </Element>
  );
}
